import { ProcedureType } from "api/type";

export function formatProcedureName(
  procedureString: ProcedureType | string | null,
  isShort = false,
) {
  if (procedureString === null) {
    return "";
  }

  if (procedureString === ProcedureType.BBL) {
    return "BBL";
  }

  if (procedureString === ProcedureType.BREAST_AUGMENTATION && isShort) {
    return "Breast Aug";
  }

  return procedureString
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
